import { createSlice } from '@reduxjs/toolkit'

const initialStateValue = {
propertyRegData:null
}

export const propertyRegData = createSlice({
  name: 'propertyRegData',
  initialState: initialStateValue,
  reducers: {
    setPropertyRegData:(state,action)=>{
      state.propertyRegData = action.payload
    },
  },
})

export const { setPropertyRegData} = propertyRegData.actions

export default propertyRegData.reducer
